import React from 'react'
import { CircularProgress, styled } from '@mui/material'

const StyledCircularProgress = styled(CircularProgress)(({ size = 40 }) => ({
  position: 'relative',
  marginLeft: '50%',
  left: `-${size / 2}px`,
  top: '1rem',
}))

const Spinner = ({ color, size = 40, ...other }) => (
  <StyledCircularProgress color={color || 'primary'} size={size} {...other} />
)

export default Spinner
